<div class="btn-group"
     ngbDropdown>
  <a ngbDropdownToggle
     class="era-dropdown-toggle"
     id="roomStatusDropdown">
    <era-room-status-badge [isCheckedIn]="isCheckedIn()">
      <ng-content checkin
                  select="[checkedin]"></ng-content>
      <ng-content checkout
                  select="[checkedout]"></ng-content>
    </era-room-status-badge>
  </a>

  <div ngbDropdownMenu
       aria-labelledby="roomStatusDropdown"
       class="py-0"
       [ngClass]="{ 'dropdown-menu-end': positionRight() }">
    @if (!isCheckedIn()) {
      <button ngbDropdownItem
              class="bg-success text-white"
              (click)="checkin()">
        <ng-content select="[checkin]"></ng-content>
      </button>
    } @else {
      <button ngbDropdownItem
              class="bg-danger text-white"
              (click)="checkout()">
        <ng-content select="[checkout]"></ng-content>
      </button>
    }
  </div>
</div>